import axios from 'axios';
import { WorkItemActionTypes } from './';

const endpoint = `${process.env.REACT_APP_ERP_API_HOST}/request/item/activities`;

export function createWorkItemActivity(workItemActivity, callback, errorCallback) {

  const request = axios.post(`${endpoint}`, workItemActivity);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: WorkItemActionTypes.COMMENT,
    payload: request
  }

}

export function updateWorkItemActivity(workItemActivity, callback, errorCallback) {

  const request = axios.put(`${endpoint}/${workItemActivity.id}`, workItemActivity);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: WorkItemActionTypes.COMMENT_UPDATE,
    payload: request
  }

}

export function removeWorkItemActivity(workItemActivity, callback, errorCallback) {

  console.log("removeWorkItemActivity",workItemActivity);
  const request = axios.delete(`${endpoint}/${workItemActivity.id}`);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: WorkItemActionTypes.COMMENT_DELETE,
    payload: request
  }

}







// WEBPACK FOOTER //
// ./src/actions/workitem_activity.action.js